import { MdCheckCircle } from "react-icons/md";
import { AppContext } from "../App";
import { useContext } from "react";
import { STR_BACK, STR_SUCCESS } from "../Strings";

export default function OpSuccessWidget() {

	const appContext = useContext(AppContext);

	return (
		<div className="card">
			<div className="card-body text-center">
				<MdCheckCircle
					size={72}
					style={{
						margin: "20px"
					}}
					className="text-secondary"
				/>

				<h6
					style={{
						fontSize: "24px"
					}}
					className="text-secondary"
				>
					{STR_SUCCESS[appContext.language]}
				</h6>

				<button
					className="btn btn-padded btn-rounded btn-primary"
					onClick={appContext.navBack}
					style={{
						marginTop: "80px",
						marginBottom: "20px",
					}}
				>
					{STR_BACK[appContext.language]}
				</button>
			</div>
		</div>
	)
}